export default __webpack_public_path__ + "8077b5eb9630b44a91a144eed110bf34.png";